/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('TraceDetailsServiceApi', ($http, ApiErrorService) => {
    return {
        testDetails: testDetails,
        lastPage: lastPage,
        getTraceChildren: getTraceChildren,
        getAttachmentsDto: getAttachmentsDto,
        getAttachment: getAttachment,
        deleteAttachment: deleteAttachment,
        getRawMessage: getRawMessage,
        saveNote: saveNote,
        getTestInfo: getTestInfo,
        getUserModel: getUserModel,
        getTestVariableHistory: getTestVariableHistory,
        updateTestVariableHistory: updateTestVariableHistory,
        runTest: runTest,
        cancelTest: cancelTest,
        provideTestExecutionInstructionValues: provideTestExecutionInstructionValues,
        saveUserTestCaseScript: saveUserTestCaseScript,
        getUserTestCaseScript: getUserTestCaseScript
    };
    function testDetails(req) {
        return $http.post(`api/TraceDetails/TestDetails`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function lastPage(req) {
        return $http.post(`api/TraceDetails/LastPage`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTraceChildren(traceId) {
        return $http.get(`api/TraceDetails/GetTraceChildren?traceId=${traceId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAttachmentsDto(req) {
        return $http.post(`api/TraceDetails/GetAttachmentsDto`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAttachment(id) {
        return $http.get(`api/TraceDetails/GetAttachment?id=${id}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteAttachment(id, req) {
        return $http.post(`api/TraceDetails/DeleteAttachment?id=${id}`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getRawMessage(id, getMessageOnly) {
        return $http.get(`api/TraceDetails/GetRawMessage?id=${id}&getMessageOnly=${getMessageOnly}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveNote(req) {
        return $http.post(`api/TraceDetails/SaveNote`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestInfo(testId) {
        return $http.get(`api/TraceDetails/GetTestInfo?testId=${testId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getUserModel(req) {
        return $http.post(`api/TraceDetails/GetUserModel`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestVariableHistory(testId, testerId) {
        return $http.get(`api/TraceDetails/GetTestVariableHistory?testId=${testId}&testerId=${testerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function updateTestVariableHistory(req, testerId) {
        return $http.post(`api/TraceDetails/UpdateTestVariableHistory?testerId=${testerId}`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function runTest(req) {
        return $http.post(`api/TraceDetails/RunTest`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function cancelTest(req) {
        return $http.post(`api/TraceDetails/CancelTest`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function provideTestExecutionInstructionValues(req) {
        return $http.post(`api/TraceDetails/Instruction`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveUserTestCaseScript(userTestCaseScript) {
        return $http.post(`api/TraceDetails/SaveUserTestCaseScript`, userTestCaseScript)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getUserTestCaseScript(userId, simId, testCaseId) {
        return $http.get(`api/TraceDetails/GetUserTestCaseScript?userId=${userId}&simId=${simId}&testCaseId=${testCaseId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
